import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getAnalytics } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || 'AIzaSyAyK1mo8Zf9GNFQgBgM_lohkgCCklqqOZs',
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || 'catatcrypto-prod.firebaseapp.com',
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || 'catatcrypto-prod',
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || 'catatcrypto-prod.firebasestorage.app',
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || '726324950801',
  appId: import.meta.env.VITE_FIREBASE_APP_ID || '1:726324950801:web:9ae0b68c584be500de3eb0',
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID || 'G-4RG4BBEN57'
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Auth and Google Auth Provider
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();

// Custom configurations
googleProvider.setCustomParameters({
  prompt: 'select_account'
});

// Initialize Analytics
export const analytics = typeof window !== 'undefined' ? getAnalytics(app) : null;
